module.exports = __webpack_public_path__ + "img/honor_sg_002.d781bbe.png";